import * as common from './common.js';
import * as exportsArea from './exports.js';
import * as v1 from './v1.js';
import * as v2 from './v2.js';

/**
 * Serbian for text the API sends in English: source labels and reasons, notes, limitations, availability reasons,
 * dataset descriptions and error messages. Keyed by the exact English text, so the API contract is unchanged; a test in
 * the API package runs every route on fixtures and checks that each sentence it can send has a translation here.
 */
export const SERVER_AREAS = { common, v1, v2, exports: exportsArea };

export const SERVER_TEXT: Record<string, string> = { ...common.text, ...v1.text, ...v2.text, ...exportsArea.text };

export const SERVER_PATTERNS: Array<[RegExp, (match: RegExpExecArray) => string]> = [...common.patterns, ...v1.patterns, ...v2.patterns, ...exportsArea.patterns];
